// extracted by mini-css-extract-plugin
export default {"defaultMargin":"Row_defaultMargin__427j3","defaultGap":"Row_defaultGap__cBKsq"};